/**
 * PC Remote Library
 * Author: Divya Tiwari
 * Created On: 13-03-2023
 */

import React from 'react';
import './BarChart.scss';

interface IBarChart {
  withIBObgcolor: string;
  withOutIBObgcolor: string;
  progress: string;
  barPosition: string;
  barClassName:string;
}
const BarChart = (props: IBarChart) => {
  const parentdiv = {
    width: '100%',
    backgroundColor: props.withOutIBObgcolor,
    borderRadius: 4,
    display: 'flex',
    justifyContent: props.barPosition
  };

  const childdiv = {
    height: '100%',
    width: `${props.progress}%`,
    backgroundColor: props.withIBObgcolor,
    borderRadius: 4
  };
  return (
    <div style={parentdiv} className={props.barClassName + " parentdiv"}>
      <div style={childdiv}>
        <span></span>
      </div>
    </div>
  );
};

export default BarChart;
